

import React from "react";
import { useState } from "react";

import { X, Pencil, Save } from "lucide-react"; // Import icons
import SelectWithSearch from "../components/SelectWithSearch";

const BasicInfo = () => {

    const [isEditing, setIsEditing] = useState(false);
    const [formData, setFormData] = useState({
        firstName: "Rohan",
        middleName: "Patil",
        lastName: "Patil",
        displayName: "Rohan",
        userEmail: "rohan@gmail.com",
        userMobile: "000 000 0000",
        location: "Lorem ipsum is dummy text",
        defaultWarehouse: "Delhi",
        country: "India",
        state: "Delhi",
        timeZOne: "USA",
        currency: "USD"
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSave = () => {
        setIsEditing(false);
    };

    return (
            
        <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Basic Info</h5>
                <div>
                    {isEditing ? (
                        <button onClick={handleSave} className="btn btn-success btn-sm me-2">
                        <Save size={18} className="me-1" /> Save
                        </button>
                    ) : null}
                    <button onClick={() => setIsEditing(!isEditing)} className="border-0 bg-transparent">
                        {isEditing ? <X className="text-danger" size={20} /> : <Pencil className="text-primary" size={20} />}
                    </button>
                </div>
            </div>

            <div className="card-block">
                <div className="row mb-3">
                    <div className="col-lg-4 mb-3">
                        <label className="form-label f-14">First Name</label>
                        {isEditing ? (
                            <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} className="form-control input-me f-14" />
                        ) : (
                            <p className="mb-0 f-13">{formData.firstName}</p>
                        )}
                    </div>
                    <div className="col-lg-4 mb-3">
                        <label className="form-label f-14">Middle Name</label>
                        {isEditing ? (
                            <input type="text" name="middleName" value={formData.middleName} onChange={handleChange} className="form-control input-me f-14" />
                        ) : (
                            <p className="mb-0 f-13">{formData.middleName}</p>
                        )}
                    </div>
                    <div className="col-lg-4 mb-3">
                        <label className="form-label f-14">Last Name</label>
                        {isEditing ? (
                            <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} className="form-control input-me f-14" />
                        ) : (
                            <p className="mb-0 f-13">{formData.lastName}</p>
                        )}
                    </div>
                    <div className="col-lg-4 mb-3">
                        <label className="form-label f-14">Display Name</label>
                        {isEditing ? (
                            <input type="text" name="displayName" value={formData.displayName} onChange={handleChange} className="form-control input-me f-14" />
                        ) : (
                            <p className="mb-0 f-13">{formData.displayName}</p>
                        )}
                    </div>
                    <div className="col-lg-4 mb-3">
                        <label className="form-label f-14">Email</label>
                        {isEditing ? (
                            <input type="email" name="userEmail" value={formData.userEmail} onChange={handleChange} className="form-control input-me f-14" />
                        ) : (
                            <p className="mb-0 f-13">{formData.userEmail}</p>
                        )}
                    </div>
                    <div className="col-lg-4 mb-3">
                        <label className="form-label f-14">User Mobile</label>
                        {isEditing ? (
                            <input type="email" name="userMobile" value={formData.userMobile} onChange={handleChange} className="form-control input-me f-14" />
                        ) : (
                            <p className="mb-0 f-13">{formData.userMobile}</p>
                        )}
                    </div>
                    <div className="col-lg-4 mb-3">
                        <label className="form-label f-14">Country</label>
                        {isEditing ? (
                            <select name="country" className="form-control input-me f-14" value={formData.country} onChange={handleChange}>
                                <option>India</option>
                                <option>USA</option>
                                <option>AUS</option>
                                <option>Japan</option>
                            </select>
                        ) : (
                            <p className="mb-0 f-13">{formData.country}</p>
                        )}
                    </div>
                    <div className="col-lg-4 mb-3">
                        <label className="form-label f-14">State</label>
                        {isEditing ? (
                            <select name="state" className="form-control input-me f-14" value={formData.state} onChange={handleChange}>
                                <option>UP</option>
                                <option>MP</option>
                                <option>AP</option>
                            </select>
                        ) : (
                            <p className="mb-0 f-13">{formData.state}</p>
                        )}
                    </div>
                    <div className="col-lg-4 mb-3">
                        <label className="form-label f-14">Time Zone</label>
                        {isEditing ? (
                            <select name="timeZone" className="form-control input-me f-14" value={formData.timeZone} onChange={handleChange}>
                                <option>Delhi, India</option>
                                <option>USA</option>
                            </select>
                        ) : (
                            <p className="mb-0 f-13">{formData.timeZone}</p>
                        )}
                    </div>
                    <div className="col-lg-4 mb-3">
                        <label className="form-label f-14">Currency</label>
                        {isEditing ? (
                            <SelectWithSearch 
                                name="currency" 
                                value={formData.currency} 
                                onChange={handleChange} 
                            />
                        ) : (
                            <p className="mb-0 f-13">{formData.currency}</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
        
    );
};

export default BasicInfo;